import EAAccordion from "../EAAccordion";
import EAFieldset from "../EAFieldset";
import * as PropTypes from "prop-types";
import React from "react";

const id = "erweiterteSuche";
/**
 * Attribute im Filter
 */
const attr = {
    verwaltungseinheit: "verwaltungseinheit",
    wasserkoerper: "wasserkoerper",

    regionalstelle: "regionalstelle",
    aktenzeichen: "aktenzeichen",
    bescheidsdatum: "bescheidsdatum",
    behoerde: "behoerde",

    gueltigVon: "gueltigVon",
    gueltigBis: "gueltigBis",
};

function ErweiterteSuche(props) {
    return (
        <EAAccordion
            label="Erweiterte Suche"
            wrapperClassName="extendedFilter"
            className="gridl"
            id={id}
            variant="light"
            expanded={props.sharedFilter.extendedSearchOpen ? props.sharedFilter.extendedSearchOpen : false}
            onChange={(_e, expanded) => props.onExtendedSearchOpenChanged(expanded)}
        >
            {React.Children.toArray(props.additionalPrefixFields)}
            {props.sharedFormFactory.renderAutocompletePersonalisiert(
                "raeumlich",
                id + "-raeumlich",
                "Räumliches Kriterium",
                props.raeumlichesKriteriumOptionen.data,
                "value",
                (o) => `${o.verwaltungseinheit}${o.wasserkoerper}`,
                props.raeumlichesKriteriumOptionen.loading,
                false,
                false,
                {style: {gridColumn: "span 2"}},
                null,
                props.raeumlichesKriteriumPersonalisiert
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.regionalstelle,
                id + "-" + attr.regionalstelle,
                "Regionalstelle",
                props.regionalstelleOptionen.data,
                "value",
                "id",
                props.regionalstelleOptionen.loading
            )}
            {props.sharedFormFactory.renderDatePickerPersonalisiert(
                attr.gueltigVon,
                id + "-" + attr.gueltigVon,
                "Gültig von",
                false,
                props.sharedFilter.personalisiert
            )}
            {props.sharedFormFactory.renderDatePickerPersonalisiert(
                attr.gueltigBis,
                id + "-" + attr.gueltigBis,
                "Gültig bis",
                false,
                props.sharedFilter.personalisiert
            )}

            <EAFieldset id={id + "-bescheidfieldset"} caption="Bescheid" style={{gridRow: 2, gridColumn: "span 6"}}>
                <div className="gridl" style={{gridTemplateColumns: "250px 130px 1fr", alignItems: "center"}}>
                    {props.sharedFormFactory.renderInput(attr.aktenzeichen, id + "-" + attr.aktenzeichen, "Aktenzeichen")}
                    {props.sharedFormFactory.renderDatePicker(attr.bescheidsdatum, id + "-" + attr.bescheidsdatum, "Bescheidsdatum")}
                    {props.sharedFormFactory.renderAutocomplete(
                        attr.behoerde,
                        id + "-" + attr.behoerde,
                        "Behörde",
                        props.behoerdeOptionen.data,
                        "bezeichnung",
                        "id",
                        props.behoerdeOptionen.loading
                    )}
                </div>
            </EAFieldset>
            {React.Children.toArray(props.additionalSuffixFields)}
        </EAAccordion>
    );
}

export default ErweiterteSuche;
ErweiterteSuche.propTypes = {
    onExtendedSearchOpenChanged: PropTypes.func,
    formFactory: PropTypes.any,
    additionalPrefixFields: PropTypes.any,
    additionalSuffixFields: PropTypes.any,
};
